module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer"
  }, [_c('div', {
    class: [_vm.active ? 'not-visible' : '', 'file'],
    on: {
      "click": _vm.showOptions
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-3x"
  }, [_c('i', {
    staticClass: "fa fa-file fa-stack-2x"
  }), _vm._v(" "), _c('strong', {
    staticClass: "fa-stack-1x file-text"
  }, [_vm._v(_vm._s(_vm.extension))])]), _vm._v(" "), _c('div', {
    staticClass: "file-name"
  }, [_vm._v("\n      " + _vm._s(_vm.fileName) + "\n    ")])]), _vm._v(" "), _c('div', {
    class: [_vm.active ? 'visible' : '', 'abs'],
    style: ({
      width: _vm.buttonBoxWidth + 'px'
    })
  }, [_c('div', {
    class: [_vm.active ? 'visible' : '', 'action']
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.active = !_vm.active
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.remove
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ba78a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/library/components/File.vue
// module id = 2120
// module chunks = 1